/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TreatmentAdverseEvent from './treatment-adverse-event';
import TreatmentAdverseEventDetail from './treatment-adverse-event-detail';
import TreatmentAdverseEventUpdate from './treatment-adverse-event-update';
import TreatmentAdverseEventDeleteDialog from './treatment-adverse-event-delete-dialog';

const TreatmentAdverseEventRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TreatmentAdverseEvent />} />
    <Route path="new" element={<TreatmentAdverseEventUpdate />} />
    <Route path=":id">
      <Route index element={<TreatmentAdverseEventDetail />} />
      <Route path="edit" element={<TreatmentAdverseEventUpdate />} />
      <Route path="delete" element={<TreatmentAdverseEventDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TreatmentAdverseEventRoutes;
